import { Stack, Typography } from '@mui/material';
import tokens from '@verifime/design-tokens';
import { DvsErrorTooltip } from './DvsErrorTooltip';
import { TDvsStatusWithErrorDetails } from './types';

/**
 * Component for displaying DVS status and error details
 */
export const DvsStatusDisplay = ({
  status,
  errorDetails,
}: Readonly<TDvsStatusWithErrorDetails>) => {
  return (
    <Stack direction="row" gap={tokens.spacingXs}>
      {status && (
        <Typography color={status === 'Passed' ? 'success.main' : 'error.main'}>
          {status}
        </Typography>
      )}
      {errorDetails && <DvsErrorTooltip errorDetails={errorDetails} />}
    </Stack>
  );
};
